var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.current > -1)?_c('a',{staticClass:"page-nav",class:_vm.parentStyles,on:{"click":_vm.goTo}},[_c('div',{style:(_vm.styles)},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"size":"2x","icon":"play"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }